import { context } from '@shared-services/context-service';
import { getWindowInBrowser } from 'client/RuntimeWindow';
import { UrlAction } from '../types';

export const URL_PARAM_KEYS = {
    SLUG: 'slug',
    ACTION: 'action',
    TEAM_ID: 'teamId',
    BOOKING_UID: 'bookingUid',
    USERNAME: 'username',
    SELECTED_HOST_ID: 'selectedHostId',
    RESCHEDULE: 'reschedule',
    CANCEL: 'cancel',
    ALL_REMAINING_BOOKINGS: 'allRemainingBookings',
} as const;

let __bookingUrlParams: Record<string, string> | null = null;

(function () {
    if (context.isServer || typeof window === 'undefined') {
        return;
    }
    initBookerUrlParams();
})();

export function initBookerUrlParams() {
    const location = new URL(getWindowInBrowser().location.href);
    const urlParams = new URLSearchParams(location.search);
    const isActionUrl = urlParams.get(URL_PARAM_KEYS.ACTION);

    if (isActionUrl) {
        // set bookingUrlParams for consumption by the widget
        __bookingUrlParams = Object.fromEntries(urlParams.entries());
        const widget = getWindowInBrowser().document.querySelector(
            `[data-widget-type="ssrcalbooking"]`
        );
        if (widget) {
            // scroll to the widget in order to trigger the widget to hydrate
            widget.scrollIntoView();
        }
        // clear the url params
        setTimeout(() => {
            Object.values(URL_PARAM_KEYS).forEach((key) =>
                location.searchParams.delete(key)
            );
            history.replaceState(null, '', location);
        }, 0);
    }
}

interface BookingUrlResult {
    slug: string;
    action: string;
    teamId: number;
    bookingUid: string;
    username: string;
    isUrlAction: boolean;
    selectedHostId?: number;
}

export function resolveUrlParams(dryrunMode: boolean) {
    if (dryrunMode || context.isServer || !__bookingUrlParams) {
        return {
            slug: undefined,
            action: undefined,
            teamId: undefined,
            bookingUid: undefined,
            username: undefined,
            isUrlAction: false,
            selectedHostId: undefined,
        };
    }

    const result: BookingUrlResult = {
        slug: __bookingUrlParams.slug,
        action: __bookingUrlParams.action,
        bookingUid: __bookingUrlParams.bookingUid,
        username: __bookingUrlParams.username,
        teamId: parseInt(__bookingUrlParams.teamId),
        isUrlAction: [UrlAction.RESCHEDULE, UrlAction.CANCEL].includes(
            __bookingUrlParams.action as UrlAction
        ),
        selectedHostId: __bookingUrlParams.selectedHostId
            ? parseInt(__bookingUrlParams.selectedHostId)
            : undefined,
    };
    // clear bookingUrlParams for next consumption
    __bookingUrlParams = null;

    return result;
}
